<div *ngIf="listItems.length" class="list-items">
    <div class="single-item-label label" *ngIf="showPeriod">
        {{ getDisplayName(listItems[0]) }}
    </div>
    <div *ngIf="!showPeriod" class="all-permissons-line">
        <span class="label m-r-xs m-b-xs" *ngFor="let p of listItems">
        {{ getDisplayName(p) }}
    </span>
    </div>

    <button *ngIf="listItems.length > 1 && showPeriod" class="list-items__btn" (click)="toggle()">...</button>

    <div class="list-items__drop-down" [class.active]="isShow" [class.list-items__drop-down_up]="isDirectionTop">
        <div class="list-items__drop-down__content">
            <span *ngFor="let item of listItems | slice:1" [class]="'label label_' + item.permission">
                {{ getDisplayName(item) }}
            </span>
        </div>
    </div>
</div>




// WEBPACK FOOTER //
// /app/src/app/components/list-with-hint/list-with-hint.component.html